module.exports = __webpack_public_path__ + "img/mgh-kanazawa-sp@2x.69bc2f85.jpg";